<template>
    <div class="typing-card block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <span class="botter-Typing-icon white--text text-lg-2" />
                        </div>

                        <h4>Show "typing…" for at least <span class="text--error" v-if="!validData">(Invalid Card Data)</span></h4>
                    </div>
                </template>
                <div class="block-card-body" v-if="validData">
                    <v-slider
                            v-model="value"
                            @change="updateValue"
                            :thumb-size="30"
                            :max="8"
                            :min="1"
                            thumb-label="always"
                    ></v-slider>
                    <label style = "float: right">Seconds</label>
                </div>
                <slot name = "tail" />
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-image-url",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            validData: {
              type: Boolean,
              default: ()=> {
                return false
              }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common,
                value: 1
            }
        },
        mounted() {
            this.value = Math.round(this.data.for / 1000)
        },
        methods: {
            updateValue() {
                this.data.for = this.value * 1000
            }
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>
